import { API_URL } from "../../utils/contextHelpers";
import { api, apiPost, buildQuery } from "./core";

export const getDatosCliente = api("getDatosCliente", (codigo) => `${API_URL}cotizacion/datos?codigo=${codigo}`);

export const getInfoCliente = api("getInfoCliente", (codigo) => `${API_URL}cliente/info?codigo=${codigo}`);

const _getProductosMasVendidos = api("getProductosMasVendidos", (codigo, cantidad) => `${API_URL}cotizacion/productosMasVendidos?${buildQuery({ codigo, cantidad: String(cantidad) })}`);
export const getProductosMasVendidos = (codigo, cantidad = 10) =>
    _getProductosMasVendidos(codigo, cantidad).then(data => data?.masVendidos || []);

const _getSincronizarCliente = api("getSincronizarCliente", (codigo, index) => `${API_URL}cliente/codigo?${buildQuery({ codigo, index })}`);
export const getSincronizarCliente = (codigo, index) =>
    _getSincronizarCliente(codigo, index).then(data => data?.cliente || {});

export const postGrabarClienteBoleta = api("grabar", (nombre, telefono, correo) => {
    const params = new URLSearchParams({
        nombre: String(nombre || "").trim(),
        telefono: String(telefono || "").trim(),
        correo: String(correo || "").trim(),
    });
    return `${API_URL}clienteBoleta/grabar?${params.toString()}`;
});

export const getClienteBoleta = api("getClienteBoleta", (id) => `${API_URL}mantenedor/clienteBoleta/input?id=${encodeURIComponent(id)}`);

export const publicarCliente = apiPost("publicarCliente", () => `${API_URL}cliente/publicar`, {
    body: (cliente) => new URLSearchParams(cliente).toString()
});

export const getClienteRescatar = api("getClienteRescatar", (rut) => `${API_URL}cliente/rescatar?rut=${rut}`);

export const getNuevo = api("getNuevo", () => `${API_URL}cliente/nuevo`);